import axios from "axios";
import { getStaticIP } from "../HelperFunctions";
import { notify } from "../SnackbarContext";
const apiClient = axios.create({
  // baseURL: "http://182.18.144.153:9039/", //cloud(Jitendra Sir)
  baseURL: process.env.REACT_APP_API_URL,
  // baseURL: "http://192.168.1.38:5000/", // Harsh Sir
  // baseURL: "http://192.168.1.47:5283/", // vpn
  // baseURL: "http://localhost:5293/", // Harsh Sir
  // baseURL: 'http://182.18.144.153:500/',
  // baseURL: 'http://192.168.1.35:9876',
  headers: {
    "Content-Type": "application/json",
  },
});

export const serviceLogin = async (controllerName, endPoint, dto) => {
  try {
    const response = await apiClient.post(
      `/api/${controllerName}/${endPoint}`,
      dto,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response:", error.response.data);
      console.error("Error status:", error.response.status);
      console.error("Error headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    throw error;
  }
};
export const postResource = async (dto, controllerName, endPoint) => {
  getStaticIP();
  try {
    let season = sessionStorage.getItem("season");
    let clientName = sessionStorage.getItem("clientName");
    let unitCode = sessionStorage.getItem("unitCode");
    let operatorCode = sessionStorage.getItem("operatorCode");
    let username = sessionStorage.getItem("username");
    let ip = localStorage.getItem("ip");
    const response = await apiClient.post(
      `/api/${controllerName}/${endPoint}?clientName=${clientName}&season=${season}&unitCode=${unitCode}&username=${username}&ip=${ip}&operatorCode=${operatorCode}`,
      dto,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      const data = error.response.data;
      const detail =
        typeof data === "string" && data ? data : data?.title || "An error occurred";
      notify.error(`Error ${error.response.status}: ${detail}`);
      throw {
        status: error.response.status,
        message: error.response.data || "An error occurred",
        error: error.response,
      };
    } else if (error.request) {
      console.error("No response from the server:", error.request);
      notify.error(
        "No response from the server. Please check your connection and try again."
      );
      throw {
        status: null,
        message: "No response received from the server",
        error: error.request,
      };
    } else {
      notify.error(`Error: ${error.message}`);
      throw {
        status: null,
        message: error.message,
        error: error.message,
      };
    }
  }
};

// http://192.168.1.35:9876/api/Menu/MemuLevel1?clientName=asmoli&season=2324&appName=master&opCode=55&unitCode=14

export const getResource = async (controllerName, endPoint, params = {}) => {
  try {
    let season = sessionStorage.getItem("season");
    let clientName = sessionStorage.getItem("clientName");
    let unitCode = sessionStorage.getItem("unitCode");
    const urlParams = new URLSearchParams(params).toString();
    const config = {
      method: "get",
      maxBodyLength: Infinity,
      url: urlParams
        ? `/api/${controllerName}/${endPoint}?clientName=${clientName}&season=${season}&unitCode=${unitCode}&${urlParams} `
        : `/api/${controllerName}/${endPoint}?clientName=${clientName}&season=${season}&unitCode=${unitCode}`,
      headers: {},
    };

    const res = await apiClient.request(config);
    return res.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

// For use params = {} in get api
//   const params1 = { clientName: 'ClientA', season: 'Summer', unitCode: '123' };
// const data1 = await getResource('controller1', 'endpoint1', params1);
